module.exports = __webpack_public_path__ + "static/media/dos.ce2ded17.jpg";